import { authHeader, handleResponse } from '../../helpers';

export const createCompany = ({
  name,
  email,
  password,
  withdrawalDeadline,
  userLimit,
}) => {
  const headers = authHeader();
  headers['Content-Type'] = 'application/json';
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify({
      name,
      email,
      password,
      withdrawalDeadline: Number(withdrawalDeadline),
      userLimit: Number(userLimit),
      photoUrl: '',
    }),
    headers,
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}companies`,
    requestOptions
  ).then(handleResponse);
};
export const updateCompany = (
  id,
  { name, email, password, withdrawalDeadline, userLimit }
) => {
  const headers = authHeader();
  headers['Content-Type'] = 'application/json';
  const requestOptions = {
    method: 'PUT',
    body: JSON.stringify({
      name,
      email,
      password,
      withdrawalDeadline: parseInt(withdrawalDeadline, 10),
      userLimit: parseInt(userLimit, 10),
      photoUrl: '',
    }),
    headers,
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}companies/${id}`,
    requestOptions
  ).then(handleResponse);
};

export const payCompany = (id) => {
  const headers = authHeader();
  headers['Content-Type'] = 'application/json';
  const requestOptions = {
    method: 'POST',
    headers,
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}companies/${id}/pay-monthly-payment`,
    requestOptions
  ).then(handleResponse);
};

export const deleteCompany = (id) => {
  const headers = authHeader();
  headers['Content-Type'] = 'application/json';
  const requestOptions = {
    method: 'PUT',
    body: JSON.stringify({
      deleted: 1,
    }),
    headers,
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}companies/${id}`,
    requestOptions
  ).then(handleResponse);
};

export const getCompanies = ({ page }) => {
  const headers = authHeader();
  const requestOptions = {
    method: 'GET',
    headers,
  };

  const query = `?page=${page}&limit=20`;

  return fetch(
    `${process.env.REACT_APP_API_URL}companies${query}`,
    requestOptions
  ).then(handleResponse);
};

export const getInvestmentClosings = ({ page }) => {
  const headers = authHeader();
  const requestOptions = {
    method: 'GET',
    headers,
  };

  const query = `?page=${page}&limit=20`;

  return fetch(
    `${process.env.REACT_APP_API_URL}investment-closings${query}`,
    requestOptions
  ).then(handleResponse);
};

export const getInvestmentClosing = ({ id }) => {
  const headers = authHeader();
  const requestOptions = {
    method: 'GET',
    headers,
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}investment-closings/${id}`,
    requestOptions
  ).then(handleResponse);
};

export const getClosingSummaries = ({ id }) => {
  const headers = authHeader();
  const requestOptions = {
    method: 'GET',
    headers,
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}investment-closings/${id}/closing-summaries`,
    requestOptions
  ).then(handleResponse);
};

export const updateInvestmentClosing = ({ id }) => {
  const headers = authHeader();
  const requestOptions = {
    method: 'PUT',
    headers,
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}investment-closings/${id}`,
    requestOptions
  ).then(handleResponse);
};

export const investInvestmentClosing = ({ id, investBody }) => {
  const headers = authHeader();
  const requestOptions = {
    method: 'PUT',
    body: JSON.stringify(investBody),
    headers,
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}investment-closings/${id}/invest`,
    requestOptions
  ).then(handleResponse);
};
